import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Utils from '@app/shared/utils/utils';

@Component({
  selector: 'app-filter-logs',
  templateUrl: './filter-logs.component.html',
  styleUrls: ['./filter-logs.component.sass'],
})
export class FilterLogsComponent implements OnInit, OnChanges {
  @Output() filterCleared: EventEmitter<void> = new EventEmitter();
  @Output() idTradeChange: EventEmitter<{ idTrade: string; selectedStatus: any }> =
    new EventEmitter();
  @Output() dateRangeChanged: EventEmitter<{ _startDate: string; _endDate: string }> =
    new EventEmitter();
  @Input() isErrorBoard?: boolean = false;
  @Input() listStatus: any[] = [];
  filterLogsForm: FormGroup;
  isSearching: boolean = false;
  @Output()
  statusTrade = new EventEmitter<{ statusTrade: any }>();
  listStatusTradeSelected: string | null = null;
  constructor(private formBuilder: FormBuilder) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['listStatus']) {
    }
  }
  ngOnInit(): void {
    this.filterLogsForm = this.formBuilder.group({
      startDate: [''],
      endDate: [''],
      idTrade: [''],
    });

    this.filterLogsForm.get('idTrade').valueChanges.subscribe((value: string) => {
      const upperValue = value?.toUpperCase() || '';
      if (value !== upperValue) {
        this.filterLogsForm.get('idTrade').setValue(upperValue, { emitEvent: false });
      }

      if (upperValue.trim() === '') {
        const idTrade = '';
        this.idTradeChange.emit({
          idTrade,
          selectedStatus: this.listStatusTradeSelected,
        });
        this.resetFiltersSilently();
      }
    });
  }

  private resetFiltersSilently(): void {
    this.filterLogsForm.patchValue(
      {
        idTrade: '',
        startDate: '',
        endDate: '',
      },
      { emitEvent: false }
    );

    this.isSearching = false;
    this.filterCleared.emit();
  }

  clearIdTrade(): void {
    this.resetFiltersSilently();
  }

  idTradeSearch(): void {
    const { idTrade } = this.filterLogsForm.value;

    this.idTradeChange.emit({
      idTrade,
      selectedStatus: this.listStatusTradeSelected,
    });
    this.isSearching = true;
  }

  onButtonClick(): void {
    this.idTradeSearch();
  }

  startDateChange() {
    const { startDate, endDate } = this.filterLogsForm.value;

    if (!startDate && !endDate) {
      this.dateRangeChanged.emit({ _startDate: '', _endDate: '' });
      return;
    }

    if (startDate && endDate) {
      const _startDate = Utils.formatDate(startDate, 'YYYY-MM-DD');
      const _endDate = Utils.formatDate(endDate, 'YYYY-MM-DD');
      this.dateRangeChanged.emit({ _startDate, _endDate });
    }
  }

  clearDateRange(event: MouseEvent): void {
    event.stopPropagation();
    this.filterLogsForm.patchValue({
      startDate: '',
      endDate: '',
    });
    this.startDateChange();
  }
  statusList = [];

  selectedStatus: any[] = [];

  removeStatus(lot: any): void {
    this.selectedStatus = this.selectedStatus.filter((item) => item.id !== lot.id);
  }
  onStatusChange(value: string): void {
    if (!value && !this.filterLogsForm.get('idTrade')?.value) {
      this.idTradeSearch();
    }
  }
}
